// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2342 ? "skylab.popsheet" : chunkId) + "." + {"2342":"aadd820b44212f60b000","9175":"d710b4fc3316200168ce"}[chunkId] + ".js";
};